export default {
  setPermission(state, { data }) {
    state.permission = data;
  },
  profile(state, {admin, smartmach, maintainer, vm}) {
    state.admin = admin
    state.smartmach = smartmach
    state.maintainer = maintainer
    state.vm = vm
  },
  show(state, { data }) {
    state.group = data;
  },
  set(state, { data }) {
    state.groups = data;
  },
  setPerm(state, { data }) {
    state.listPerm = data;
  },
  setUser(state, { data }) {
    state.listUser = data;
  },
  setCompExpire(state, { data }) {
    state.compExpire = data;
  },
  setCompSoldOut(state, { data }) {
    state.compSoldOut = data;
  },
  setFlag(state, { data }) {
    state.flag = data;
  },
  setOrder(state, { data }) {
    state.order = data;
  },
  setPriceCost(state, { data }) {
    state.priceCost = data;
  },

}